import "./BodhiCard.css";

const BodhiCard = ({
	children,
	label,
	title,
	description,
	accent,
	hoverable = true,
	wide = false,
	elevated = false,
	flat = false,
	ghost = false,
	glow = false,
	className = "",
	style,
	...rest
}) => {
	const cls = [
		"bodhi-card",
		hoverable && "bodhi-card-hoverable",
		wide && "bodhi-card-wide",
		accent && `bodhi-card-${accent}`,
		elevated && "bodhi-card-elevated",
		flat && "bodhi-card-flat",
		ghost && "bodhi-card-ghost",
		glow && "bodhi-card-glow",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div className={cls} style={style} {...rest}>
			{label && <div className="bodhi-card-label">{label}</div>}
			{title && <h3 className="bodhi-card-title">{title}</h3>}
			{description && <p className="bodhi-card-description">{description}</p>}
			{children}
		</div>
	);
};

export default BodhiCard;
